import { render } from "./Richieste.vue?vue&type=template&id=d1a3a798"
import script from "./Richieste.vue?vue&type=script&lang=js"
export * from "./Richieste.vue?vue&type=script&lang=js"
script.render = render

export default script